import { h, Host } from '@stencil/core';
import { getQueryParam, addParameterToLink } from '../../../globals/utils/helpers';
export class RangeNodes {
  constructor() {
    this.backUrl = undefined;
    this.backUrlTitle = undefined;
    this.levelTitle = undefined;
    this.childrenNodes = undefined;
    this.isPBS = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  nodeUrlWithParameters(url) {
    const hash = window.location.hash.substring(1);
    return addParameterToLink(url, {
      filter: getQueryParam('filter'),
    }, hash);
  }
  render() {
    var _a;
    return (h(Host, null, this.backUrl && (h("pes-range-node-header", { backUrl: this.backUrl, backUrlTitle: this.backUrlTitle, levelTitle: this.levelTitle, isPBS: this.isPBS })), ((_a = this.childrenNodes) === null || _a === void 0 ? void 0 : _a.length) > 0 && (h("ul", { class: "range-nodes-list" }, this.childrenNodes.map((node) => (h("li", { class: "range-nodes-list__item", key: node.id }, h("pes-range-node-card", { image: node.image, url: this.nodeUrlWithParameters(node.url), name: node.name, id: node.id, nodes: node.nodes, nodeReference: node.nodeReference, isPBS: this.isPBS, navigationState: node.navigationState }))))))));
  }
  static get is() { return "pes-range-nodes"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-nodes.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-nodes.css"]
    };
  }
  static get properties() {
    return {
      "backUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "back-url",
        "reflect": false
      },
      "backUrlTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "back-url-title",
        "reflect": false
      },
      "levelTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "level-title",
        "reflect": false
      },
      "childrenNodes": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "RangeNode[]",
          "resolved": "RangeNode[]",
          "references": {
            "RangeNode": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
